module.exports = __webpack_public_path__ + "static/img/NG.5a9f63be.png";